import React from "react";

import styled from "../../theme/styled";
import {
  colourHelper,
  fontLineHeightHelper,
  fontSizeHelper
} from "../../theme/theme-helper";
import Icon from "../icon";
import Link from "../link";

interface IHeroTags {
  initialTheme: "dark" | "light";
  featuredPath: string;
  tags: IHeroTag[];
}

interface IHeroTag {
  name: string;
  path: string;
}

interface IHeroTagStyled {
  initialTheme: "dark" | "light";
}

const HeroTagsStyled = styled<IHeroTagStyled, "ul">("ul")`
  transition: 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-top: 3.2rem;
  padding-left: 0;
  padding-bottom: 0;
  list-style: none;
  font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_1"
  })};
  line-height: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "small"
    })};

  li {
    transition: 0.2s ease-in-out;
    margin-bottom: 0;
    padding-top: 0.6rem;
    padding-bottom: 0;

    &:first-child {
      padding-top: 0;
    }

    a {
      display: inline-block;
      margin-bottom: 0.4rem;
      padding-bottom: 0.2rem;
      text-decoration: none;
      color: ${({ theme, initialTheme }) =>
    initialTheme === "dark" ?
      "rgba(255, 255, 255, 0.6)" :
      "rgba(0, 0, 0, 0.6)"};
      border-bottom: 0.2rem solid transparent;

      &.active {
        color: ${({ theme, initialTheme }) =>
    initialTheme === "dark" ?
      colourHelper({
        theme,
        variant: "white"
      }) :
      colourHelper({
        theme,
        variant: "brandColor"
      })};
        border-bottom-color: ${({ theme, initialTheme }) =>
    initialTheme === "dark" ?
      "rgba(255, 255, 255, 0.6)" :
      colourHelper({
        theme,
        variant: "brandColorLight"
      })};

        &:hover {
          border-bottom-color: ${({ theme, initialTheme }) =>
    initialTheme === "dark" ?
      colourHelper({
        theme,
        variant: "white"
      }) :
      colourHelper({
        theme,
        variant: "brandColor"
      })};
        }
      }

      &:hover {
        color: ${({ theme, initialTheme }) =>
    initialTheme === "dark" ?
      colourHelper({
        theme,
        variant: "white"
      }) :
      colourHelper({
        theme,
        variant: "brandColor"
      })};
      }
    }

    .icon {
      display: none !important;
      fill: ${({ theme, initialTheme }) =>
    initialTheme === "dark" ?
      colourHelper({
        theme,
        variant: "white"
      }) :
      colourHelper({
        theme,
        variant: "brandColor"
      })};
    }
  }

  @media (min-width: 480px) {
    flex-direction: row;
    align-items: center;
    padding-left: 3.2rem;

    li {
      position: relative;
      padding-top: 1.4rem;
      padding-right: 0.8rem;
      width: 50%;

      .icon {
        display: inline-block !important;
        position: absolute;
        top: 0.4rem;
        left: -3.2rem;
      }
    }
  }

  @media (min-width: 600px) {
    padding-top: 1.8rem;

    li {
      padding-top: 1.8rem !important;
      width: 33%;

      .icon {
        top: 2rem;
      }
    }
  }

  @media (min-width: 768px) {
    padding-top: 4.2rem;

    li {
      width: 25%;
    }
  }

  @media (min-width: 960px) {
    li {
      width: 20%;
    }
  }

  @media (min-width: 1280px) {
    font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_2"
  })};
  }
`;

const HeroTags = ({
  initialTheme, featuredPath, tags
}: IHeroTags) => {
  return (
    <HeroTagsStyled
      className="hero-tags-container"
      initialTheme={initialTheme}
    >
      <li>
        <Link
          type="none"
          activeClassName="active"
          href={featuredPath}
        >
          Everything
        </Link>

        <Icon
          className="icon"
          icon="tags"
          size={1.4}
        />
      </li>

      {tags.map((tag, i) => (
        <li key={i}>
          <Link
            type="none"
            activeClassName="active"
            href={tag.path}
            getProps={({ isPartiallyCurrent }) => {
              return isPartiallyCurrent ? { className: "active" } : {};
            }}
          >
            {tag.name}
          </Link>
        </li>
      ))}
    </HeroTagsStyled>
  );
};

export default HeroTags;
